module.exports = __webpack_public_path__ + "img/arrow-guide.50b87a48.svg";